export default {"src":"/_next/static/media/helloeroRedRotate.c8b1210d.svg","height":401,"width":116,"blurWidth":0,"blurHeight":0};